<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <div class="m-background__overlay"></div>
    <img src="~@/assets/images/rics-logo.png" class="m-logo m-logo--top-right" />
    <div class="l-container">
      <div class="v-confidence-survey">
        <div class="is-full">
          <h5 class="u-text--white u-text--center">
            How likely are you to want to pursue a career in surveying?
          </h5>
        </div>
        <br />
        <div class="columns is-centered">
          <div class="column is-3">
            <img class="v-confidence-media" src="~@/assets/images/career/unlikely.svg" />
            <a class="m-btn m-btn__primary"
            @click="updatingPursueCareer(1)" to="/final-screen">Unlikely</a>
          </div>
          <div class="column is-3">
            <img class="v-confidence-media" src="~@/assets/images/career/likely.svg" />
            <a class="m-btn m-btn__primary"
            @click="updatingPursueCareer(2)" to="/final-screen">Likely</a>
          </div>
          <div class="column is-3">
            <img class="v-confidence-media" src="~@/assets/images/career/very-likely.svg" />
            <a class="m-btn m-btn__primary"
            @click="updatingPursueCareer(3)" to="/final-screen">Very Likely</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['updatePursueCareer']),
    updatingPursueCareer(confidence) {
      this.updatePursueCareer(confidence);
      this.$router.push({ name: 'gameOverWin' });
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-confidence-survey {
    margin-top: 170px;
  }
  .v-confidence-media {
    width: 80px;
    margin: 0 auto 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/PursueCareer.vue